import type { TFunction } from "i18next";
import { ConsumerType } from "../../../model/energy-profile";
import { Money } from "../../../model/common/money";
import { StatementOfAccountTransaction } from "../../../model/vending/vending-interfaces";

// Maps the backend `transactionType` string to a friendly label. The endpoint (and therefore the
// possible transaction types) is chosen by meter type, so the mapping branches on consumerType.
export const transactionTypeLabel = (transactionType: string, consumerType: ConsumerType | undefined, t: TFunction): string => {
	if (consumerType === ConsumerType.Postpaid) {
		if (transactionType === "payment") return t("history.web.payment");
		if (transactionType === "bill") return t("history.web.bill");
		return t("history.web.billPayment");
	}
	if (transactionType === "token_purchase") return t("history.web.tokenPurchase");
	if (transactionType === "token_borrow") return t("history.web.tokenBorrow");
	return t("history.web.vend");
};

// Prepaid uses `amount`; postpaid uses `credit` for payments and `debit` for bill.
export const transactionMoney = (transaction: StatementOfAccountTransaction, consumerType: ConsumerType | undefined): Money | null => {
	if (consumerType === ConsumerType.Postpaid) {
		return transaction.transactionType === "payment" ? transaction.credit : transaction.debit;
	}
	return transaction.amount;
};
